/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Button, Row, Col, Tabs, Popconfirm, Modal, Input, Tooltip } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import Map from '../../components/MapOld';
import app from '../../core/constants';
import history from '../../core/utils/history';
import Layout from '../../components/layout/Layout';
import Avatar from '../../components/elements/Avatar';
import FilterSidebar from '../../components/FilterSidebar';
import Icon from '../../components/elements/Icon';
import StyledList from '../../components/StyledList';
import AssetJourneyHistoryTab from './tabs/assetJourneyHistory';
import AssetJourneyHistoryFilter from './forms/assetJourneyHistoryFilter';
import AssetEventHistoryTab from './tabs/assetEventHistory';
import AssetEventHistoryFilter from './forms/assetEventHistoryFilter';
import AssetVideoHistoryTab from './tabs/assetVideoHistory';
import AssetVideoHistoryFilter from './forms/assetVideoHistoryFilter';
import AssetServiceAlertsTab from './tabs/assetServiceAlerts';
import AssetServiceAlertsFilter from './forms/assetServiceAlertsFilter';
import { ArrowLeft } from '@carbon/icons-react';
import moment from 'moment';
import { DeviceType, UserRole } from '../../types/types';

import './assetView.scss';

const { GOOGLE_MAP_API_KEY } = app;

export default function () {
    const {
        singleAsset,
        actions,
        match,
        isFetching,
        isFetchingJourneys,
        user,
        companyUsers,
    } = this.props;
    const {
        currentTabKey,
        deleteDataConfirmButtonVisible,
        isDeleteDataModalVisible,
        displayFilter,
        assetJourneyTabLoaded,
        assetJourneys,
        assetJourneysPagination,
        isLoadingAssetJourneys,
        isExportingAssetJourneyCsv,
        eventHistoryTabLoaded,
        assetEvents,
        assetEventsPagination,
        isLoadingAssetEvents,
        isExportingAssetEventHistoryCsv,
        videoHistoryTabLoaded,
        serviceAlertsTabLoaded,
    } = this.state;

    const { asset_id } = match.params;
    let filterContent = null;
    let journeyHistoryTabContent = null;
    let eventHistoryTabContent = null;
    let videoHistoryTabContent = null;
    let serviceAlertsTabContent = null;
    if (currentTabKey === '1') {
        filterContent = (
            <AssetJourneyHistoryFilter
                assetId={asset_id}
                onSubmit={this.onJourneyHistoryTabFilterChange}
            />
        );
        journeyHistoryTabContent = (
            <AssetJourneyHistoryTab
                assetId={asset_id}
                assetJourneys={assetJourneys}
                assetJourneysPagination={assetJourneysPagination}
                isLoadingAssetJourneys={isLoadingAssetJourneys}
                isExportingAssetJourneyCsv={isExportingAssetJourneyCsv}
                onExportAssetJourneyCSV={this.onExportAssetJourneyCSV}
                onPageChange={this.onJourneyHistoryTabPageChange}
                onTableChange={this.onJourneyHistoryTabSortChange}
                setLoadedState={this.assetJourneyTabLoaded}
                assetJourneyTabLoaded={assetJourneyTabLoaded}
            />
        );
    } else if (currentTabKey === '2') {
        filterContent = (
            <AssetEventHistoryFilter
                onSubmit={(filterValues) => {
                    this.onEventsTabFilterChange(filterValues);
                }}
                assetId={asset_id}
            />
        );
        eventHistoryTabContent = (
            <AssetEventHistoryTab
                assetId={asset_id}
                assetEvents={assetEvents}
                assetEventsPagination={assetEventsPagination}
                isLoadingAssetEvents={isLoadingAssetEvents}
                isExportingAssetEventHistoryCsv={isExportingAssetEventHistoryCsv}
                onExportAssetEventCSV={this.onExportAssetEventCSV}
                onPageChange={this.onEventsHistoryTabPageChange}
                onTableChange={this.onJourneyEventsTabSortChange}
                eventHistoryTabLoaded={eventHistoryTabLoaded}
                setLoadedState={this.eventHistoryTabLoaded}
            />
        );
    } else if (currentTabKey === '3') {
        // Video
        filterContent = (
            <AssetVideoHistoryFilter
                onSubmit={this.onVideoHistoryTabFilterChange}
                assetId={asset_id}
            />
        );
        videoHistoryTabContent = (
            <AssetVideoHistoryTab
                assetId={asset_id}
                onPageChange={this.onVideoHistoryTabPageChange}
                onTableChange={this.onVideoHistoryTabSortChange}
                videoHistoryTabLoaded={videoHistoryTabLoaded}
                setLoadedState={this.videoHistoryTabLoaded}
            />
        );
    } else if (currentTabKey === '4') {
        // Service alerts
        filterContent = (
            <AssetServiceAlertsFilter
                onSubmit={this.onServiceAlertsTabFilterChange}
                assetId={asset_id}
            />
        );
        serviceAlertsTabContent = (
            <AssetServiceAlertsTab
                assetId={asset_id}
                serviceAlertsTabLoaded={serviceAlertsTabLoaded}
                setLoadedState={this.serviceAlertsTabLoaded}
                companyUsers={companyUsers}
            />
        );
    }
    const centerMap = {
        lat: singleAsset.lat,
        lng: singleAsset.lon,
    };
    const mapHasLoaded = this.googleMapAccess && GOOGLE_MAP_API_KEY && centerMap?.lat && centerMap?.lng;
    const mapComponent = mapHasLoaded && singleAsset.lat !== null && singleAsset.lon !== null ? (
        <Map
            ref={this.googleMapAccess}
            apiKey={GOOGLE_MAP_API_KEY}
            showToolbar={false}
            allowStreetView={false}
            showFindCenterButton={false}
            allowZoom
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map }) => { this.googleMapAccess.current = map; }}
            zoom={11}
            randomNo={Date.now()}
            center={centerMap}
            defaultZoom={11}
            resetBoundsOnResize
            markers={[{
                title: (
                    <span style={{
                        fontSize: '14px',
                        lineHeight: '14px',
                    }}>
                        <CaretDownOutlined />
                    </span>
                ),
                lat: singleAsset.lat,
                lng: singleAsset.lon,
                onClick: () => null,
            }]}
            dataTestId='asset-details_preview-map'
        />
    ) : (
        <div>
            No GPS coordinates specified
        </div>
    );
    const labelValuePairs = [{
        label: 'Name: ',
        value: singleAsset.name,
    },
    {
        label: 'Registration: ',
        value: singleAsset.registration,
    },
    {
        label: 'Year Registered: ',
        value: singleAsset.year_registration?.toString(),
    },
    {
        label: 'Asset Category: ',
        value: singleAsset.category,
    },
    {
        label: 'Date Last Serviced: ',
        value: singleAsset.last_service != null ? moment(singleAsset.last_service).format('DD/MM/YYYY') : 'Unknown',
    },
    {
        label: 'Division: ',
        value: singleAsset.division?.name || 'None',
    },
    {
        label: 'Fuel Type: ',
        value: singleAsset.fuelTitle,
    },
    {
        label: 'Asset Make: ',
        value: singleAsset.make,
    },
    {
        label: 'Asset Model: ',
        value: singleAsset.model,
    }];
    const isFetchingAsset = isFetching.some(item => item.GET_ASSET_INFO);
    const isFetchingAssetJourneys = isFetching.some(item => item.GET_ASSET_JOURNEY);
    const isFetchingAssetEvents = isFetching.some(item => item.GET_ASSET_EVENT_HISTORY);
    const isFetchingAssetVideos = isFetching.some(item => item.GET_ASSET_HISTORIC_VIDEO);
    const isFetchingServiceAlerts = isFetching.some(item => item.GET_ASSET_SERVICE_ALERTS);
    const isLoading = isFetchingAsset || isFetchingAssetJourneys || isFetchingAssetEvents || isFetchingJourneys || isFetchingAssetVideos || isFetchingServiceAlerts;
    const dvrDevice = singleAsset?.devices?.find(d => d.type === DeviceType.Dvr);

    return (
        <Layout
            data-test="pages-view-asset"
            className="assets"
            title={<div>{singleAsset.name || 'Asset Details'}</div>}
            headerTitle={<div>{singleAsset.name || 'Asset Details'}</div>}
            showFooter={false}
            loading={isLoading}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter={displayFilter}>{filterContent}</FilterSidebar>
                <div
                    className="content"
                    style={{
                        opacity: isLoading ? 0 : 1,
                        marginTop: '-16px',
                    }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div
                                className="section__body"
                                style={{ paddingRight: '16px' }}
                            >
                                <div className="section__action-bar justify-center">
                                    <span style={{ marginRight: 'auto' }}>
                                        <Button
                                            className='btn-link'
                                            onClick={() => history.push('/assets')}
                                            style={{ verticalAlign: 'middle' }}
                                            data-testid='asset-details_back-btn'
                                        >
                                            <ArrowLeft />
                                            &thinsp;
                                            Back
                                        </Button>
                                    </span>
                                    <span style={{ marginLeft: 'auto' }}>
                                        {user.permissions.live_video === true && (
                                            <>
                                                {dvrDevice ? (
                                                    <Button
                                                        onClick={() => history.push(`/video/live-videos/${singleAsset.id}`)}
                                                        type="primary"
                                                        className="btn mr-2"
                                                        data-testid='asset-details_view-cameras-btn'
                                                    >
                                                        <span>View Cameras</span>
                                                    </Button>
                                                ) : (
                                                    <Tooltip title='Asset does not have a DVR device'>
                                                        <Button
                                                            onClick={() => history.push(`/video/live-videos/${singleAsset.id}`)}
                                                            type="primary"
                                                            className="btn mr-2"
                                                            data-testid='asset-details_view-cameras-btn'
                                                            disabled
                                                        >
                                                            <span>View Cameras</span>
                                                        </Button>
                                                    </Tooltip>
                                                )}
                                            </>

                                        )}
                                        <Button
                                            onClick={() => history.push(`/assets/edit/${singleAsset.id}`)}
                                            type="primary"
                                            className="btn mr-2"
                                            disabled={user.permissions.editing_assets === false}
                                            data-testid='asset-details_edit-btn'
                                        >
                                            <span>Edit</span>
                                        </Button>
                                        {user.permissions.editing_assets === true ? (
                                            <>
                                                {[UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin].includes(user.role) ? (
                                                    <>
                                                        <Button
                                                            className="btn btn-bordered mr-2"
                                                            onClick={this.showModal}
                                                            style={{ width: '120px' }}
                                                            data-testid='asset-details_delete-data-btn'
                                                        >
                                                            <span>
                                                                Delete Data
                                                            </span>
                                                        </Button>
                                                    </>
                                                ) : null}
                                                <Modal
                                                    icon={null}
                                                    title="Are you sure?"
                                                    open={isDeleteDataModalVisible}
                                                    onOk={this.handleOk}
                                                    onCancel={this.handleCancel}
                                                    okText="Delete"
                                                    okButtonProps={{ disabled: !deleteDataConfirmButtonVisible }}
                                                >
                                                    <br />
                                                    <p style={{
                                                        fontSize: '12px',
                                                        textAlign: 'center',
                                                    }}>
                                                        If you're sure then type 'delete' into the field below and click Delete.
                                                    </p>
                                                    <br />
                                                    <Input
                                                        onChange={(e) => this.saveDeleteText(e.target.value)}
                                                        placeholder="Type 'delete'"
                                                        style={{ marginBottom: '16px' }}
                                                        data-testid='asset-details_delete-modal_confirm-input'
                                                    />
                                                </Modal>
                                                <Popconfirm
                                                    title="Are you sure you'd like to delete this asset permanently?"
                                                    onConfirm={() => actions.deleteAssetRequest(singleAsset.id)}
                                                    okText="Delete"
                                                    cancelText="Cancel"
                                                    okType="danger"
                                                    icon={null}
                                                >
                                                    <Button
                                                        className="btn btn-bordered"
                                                        style={{ width: '132px' }}
                                                        data-testid='asset-details_delete-asset-btn'
                                                    >
                                                        <span>
                                                            Delete Asset
                                                        </span>
                                                    </Button>
                                                </Popconfirm>
                                            </>
                                        ) : null}
                                    </span>
                                </div>
                                <Row gutter={32}>
                                    <Col
                                        md={14}
                                        xl={10}
                                        xxl={9}
                                    >
                                        <StyledList
                                            labelValuePairs={labelValuePairs}
                                            dataTestId='asset-details_styled-list'
                                        />
                                    </Col>
                                    <Col
                                        md={0}
                                        xl={7}
                                        xxl={6}
                                    >
                                        <br />
                                        <br />
                                        <div className="avatar-uploader" style={{ width: '232px', height: '232px', marginLeft: 'auto', marginRight: 'auto' }}>
                                            {mapComponent}
                                            <div className="ant-upload-btn">
                                                <Icon name="location" />
                                                <div className="ant-upload-text">
                                                    Current location: {singleAsset.location || 'Unknown'}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col
                                        md={9}
                                        xl={0}
                                        xxl={0}
                                    >
                                        <br />
                                        <br />
                                        <div style={{
                                            width: '128px',
                                            height: '128px',
                                            marginBottom: '16px',
                                            display: 'inline-block',
                                            float: 'right',
                                        }}>
                                            {mapComponent}
                                        </div>
                                        <div
                                            style={{
                                                width: '128px',
                                                height: '128px',
                                                display: 'inline-block',
                                                float: 'right',
                                            }}
                                        >
                                            <Avatar
                                                placeholder="car"
                                                pictureUrl={singleAsset.pictureThumb || null}
                                                onChange={this.uploadImage}
                                                className="view-asset-avatar-small"
                                                dataTestId='asset-details_avatar-uploader'
                                            />
                                        </div>
                                    </Col>
                                    <Col
                                        md={0}
                                        xl={7}
                                        xxl={6}
                                    >
                                        <br />
                                        <br />
                                        <Avatar
                                            placeholder="car"
                                            pictureUrl={singleAsset.pictureThumb || null}
                                            onChange={this.uploadImage}
                                            className="view-asset-avatar-large"
                                            dataTestId='asset-details_avatar-uploader'
                                        />
                                    </Col>
                                </Row>
                                <Tabs
                                    onTabClick={(key) => this.handleTabChange(key)}
                                    defaultActiveKey="1"
                                    animated={false}
                                    className="tabs-restyled2"
                                >
                                    <Tabs.TabPane
                                        tab="journey history"
                                        key="1"
                                    >
                                        {journeyHistoryTabContent}
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="event history"
                                        key="2"
                                    >
                                        {eventHistoryTabContent}
                                    </Tabs.TabPane>
                                    {user.permissions.historic_video_downloading === true && (
                                        <Tabs.TabPane
                                            tab="video history"
                                            key="3"
                                        >
                                            {videoHistoryTabContent}
                                        </Tabs.TabPane>
                                    )}
                                    <Tabs.TabPane
                                        tab="service alerts"
                                        key="4"
                                    >
                                        {serviceAlertsTabContent}
                                    </Tabs.TabPane>
                                </Tabs>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
